import shippingMethodsCodes from './shippingMethodsCodes';

const { PICKUP, CASTO, DPD, INPOST } = shippingMethodsCodes;

export default [PICKUP, DPD, CASTO, INPOST];
